import { ExpandableText } from 'foundations-components/transitional/components/ExpandableText';
// @ts-expect-error untyped module
import isMobile from 'isMobile';
import { sanitize } from 'sanitize-text/sanitizers/Sanitize';
import { config, secureDocument } from 'sanitize-text/sanitizers/SanitizeConfiguration';
import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';

// Intentionally narrower than config.HTML — merchant-controlled content in a
// payment UI must not embed external resources like <img> or links <a> or a <script/>.
import { jsx as _jsx } from "react/jsx-runtime";
const ALLOWED_DESCRIPTION_TAGS = ['b', 'i', 'strong', 'em', 'u', 's', 'p', 'br', 'ul', 'ol', 'li', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
const OrderDescription = ({
  checkoutSession
}) => {
  if (!checkoutSession.descriptionHtml) {
    return null;
  }
  const descriptionHtml = () => {
    const sanitized = sanitize(checkoutSession.descriptionHtml, Object.assign({}, config.HTML, {
      elements: ALLOWED_DESCRIPTION_TAGS,
      dom: secureDocument
    }));
    return /*#__PURE__*/_jsx("div", {
      dangerouslySetInnerHTML: {
        __html: sanitized
      }
    });
  };
  return /*#__PURE__*/_jsx(CardWrapper, {
    marginBlockEnd: "400",
    children: /*#__PURE__*/_jsx(CardSection, {
      padding: "600",
      children: isMobile.any ? /*#__PURE__*/_jsx(ExpandableText, {
        children: descriptionHtml()
      }) : descriptionHtml()
    })
  });
};
export default OrderDescription;